import tools from './tools';

// Hcaptcha component
export default function () {
    let root;
    let widgetId = null;
    let focusIntervalId = null;
    let instantiated = false;

    return {
        get widgetId() {
            return widgetId;
        },

        get value() {
            return widgetId ? window.hcaptcha.getResponse(widgetId) : null;
        },

        init() {
            root = this.$root;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                window.hcaptcha.remove(widgetId);
                window.clearInterval(focusIntervalId);
            } catch (error) {}
        },

        async instantiate() {
            if (instantiated) return;

            for (let i = 0; i < 40; i++) {
                if (window.hcaptcha) break;

                await new Promise((resolve) => window.setTimeout(resolve, 50));
            }

            instantiated = true;

            widgetId = window.hcaptcha.render(root, {
                sitekey: root.dataset.sitekey,
                callback: (value) => {
                    root.nextElementSibling.value = value;
                    Helper.dispatchCustomEvent('revalidate', { attribute: tools.getName(root) });
                },
            });

            focusIntervalId = window.setInterval(() => {
                if (document.activeElement.tagName === 'IFRAME' && document.activeElement.src.includes('hcaptcha.com')) {
                    root.classList.add('focus');
                } else {
                    root.classList.remove('focus');
                }
            }, 200);
        },
    };
}
